<template>
  <div class="">
    <div class="uk-flex uk-flex-center uk-text-center">
      <h4 
        v-for="(t,i) in texts" 
        :key="i" 
        :style="{ fontSize:fontsize }" 
        class="newfont"
        style="text-align:center">{{ t }}</h4>
    </div>
    <hr class="divider">
    <div class="ctn-content">
      <ul>
        <li
          v-for="(value,key) in form"
          :key="key"
          class="flex newfont"
        >
          <h5 class="newfont medium">{{ titleMap[key] }}</h5><p class="newfont medium">- {{ value }}</p>
        </li>
      </ul>
    </div>

    <div class="nav-flex">
      <button 
        v-if="showBack" 
        class="button-std newfont" 
        @click="backstep"><span class="material-icons">chevron_left</span>Back</button>
      <button class="button-std newfont" @click="nextstep">Next<span class="material-icons">chevron_right</span></button>
    </div>

  </div>
</template>

<script>


export default {
  components: {
  
  },
  props: {
    for: {
      type:String
    },
    goto: {
      type:Number
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showExit: {
      type: Boolean,
      default: false
    },
    backto: {
      type:Number
    },
    texts: {
      type:Array,
      default: function(){
        return []
      }
    },
    form:{
      type:Object,
      default: function(){
        return {} 
      }
    },
    titleMap:{
      type:Object,
      default: function(){
        return {} 
      }
    },
    fontsize: {
      default:"1em",
      type:String
    },
    nextBtn:{
      type:Object,
      default:function(){
        return {
          styles:{
            position:"absolute",
            bottom:"-50px",
            right:"150px",
          }
        }
      }
    },
    currentFrame:{
      type:Number
    },
    event_order:{
      type:Number
    }
  },
  computed: {

  },
  watch: {
    currentFrame:function(){
      if(this.currentFrame === this.event_order){
        this.setHeight()
      }
    }
  },
  data: function(){
    return {
      hold: [],
    }
  },
  methods: {
    setHeight(){
      let f = document.getElementById(this.currentFrame)
      f.style.height = `${f.offsetHeight+400}px`
    },
    nextstep(){
      this.$emit('nextstep', {for:this.for, stepVal:this.goto})
    },
    backstep(){
      this.$emit('backstep', {for:this.for, stepVal:this.backto})
    },
  }
}
</script>


<style scoped>

h1 {
    text-align: center;
}
.transition-all {
  transition: all 333ms ease-in-out;
}

.cursor-pointer {
    cursor: pointer;
}
.divider {
    border: 2px solid #d9d9d9;
    margin: 0px 100px;
}
.card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 5px 15px #a9a9a9;
}

.ctn-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  align-items:center;
}

.nav-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items:center;
}

.newfont {
  font-family:'Varela Round';
}
.medium {
  font-size:1.4em;
}
</style>
